import { isNull } from "lodash-es"

/**
 * A broker to handle the persistent data that should be kept in the browser storage between sessions
 */
export default class PersistencyBroker {

  /**
   * Get the value from the browser storage defined by the key parameter key
   *
   * @param key
   * @returns true if attribute found / false otherwise
   */
  public static get(key: string) {
    let val = localStorage.getItem(key)
    if (isNull(val))
      return false
    else
      return val
  }

  /**
   * Set the value in the browser storage
   *
   * @param key
   * @param val
   */
  public static set(key: string, val: any): boolean {
    try {
      localStorage.setItem(key, val)
      return true
    } catch (error) {
      return false
    }
  }

  /**
   * Remove the item fromt he browser storage
   * @param key
   */
  public static remove(key: string): void {
    localStorage.removeItem(key)
  }

}